<template>
  <div class="nettdoc-paralysis-deafness-prickle">
    <SectionHeader
      text="I do have a paralysis/ deafness/ prickle"
      img="illu-card-beschwerden-paralysis"
      alt="wheelchair"
      :collapsable="true"
      v-on:collapse="() => collapsed = !collapsed"
      :complete="store.paralysisDeafnessPrickleDetails.submitted"
    />
    <template v-if="collapsed">
      <SectionHeader text="injuryOrAccident" :required="false" :dark="true" />
      <YesNo
        :model="store.paralysisDeafnessPrickleDetails.injuryOrAccident"
        v-on:action="value => store.addParalysisDeafnessPrickleDetails('injuryOrAccident', value)"
      />

      <SectionHeader text="knownBackProblems" :required="false" :dark="true" />
      <YesNo
        :model="store.paralysisDeafnessPrickleDetails.knownBackProblems"
        v-on:action="value => store.addParalysisDeafnessPrickleDetails('knownBackProblems', value)"
      />

      <SectionHeader text="slippedOrHerniatedDisc" :required="false" :dark="true" />
      <YesNo
        :model="store.paralysisDeafnessPrickleDetails.slippedOrHerniatedDisc"
        v-on:action="value => store.addParalysisDeafnessPrickleDetails('slippedOrHerniatedDisc', value)"
      />

      <SectionHeader text="neuralDisease" :required="false" :dark="true" />
      <YesNo
        :model="store.paralysisDeafnessPrickleDetails.neuralDisease"
        v-on:action="value => store.addParalysisDeafnessPrickleDetails('neuralDisease', value)"
      />

      <SectionHeader text="multipleSclerosis" :required="false" :dark="true" />
      <YesNo
        :model="store.paralysisDeafnessPrickleDetails.multipleSclerosis"
        v-on:action="value => store.addParalysisDeafnessPrickleDetails('multipleSclerosis', value)"
      />

      <SectionHeader text="tumorAffectingNervousSystem" :required="false" :dark="true" />
      <YesNo
        :model="store.paralysisDeafnessPrickleDetails.tumorAffectingNervousSystem"
        v-on:action="value => store.addParalysisDeafnessPrickleDetails('tumorAffectingNervousSystem', value)"
      />

      <SectionHeader text="alreadySufferedStroke" :required="false" :dark="true" />
      <YesNo
        :model="store.paralysisDeafnessPrickleDetails.alreadySufferedStroke"
        v-on:action="value => store.addParalysisDeafnessPrickleDetails('alreadySufferedStroke', value)"
      />

      <SectionHeader text="numbness" :required="true" :dark="true" />
      <YesNo
        :model="store.paralysisDeafnessPrickleDetails.numbness"
        v-on:action="value => store.addParalysisDeafnessPrickleDetails('numbness', value)"
      />

      <template v-if="store.paralysisDeafnessPrickleDetails.numbness === 'yes'">
        <SectionHeader text="Please mark the symptoms' location" :required="false" :dark="true" />
        <Bodyparts 
          :model="store.numbnessDetails.location"
          v-on:action="value => store.addNumbnessDetails('location', value)"
        />
        <SectionHeader text="differentPerceptionInBodyHalfs" :required="false" :dark="true" />
        <YesNo 
          :model="store.numbnessDetails.differentPerceptionInBodyHalfs"
          v-on:action="value => store.addNumbnessDetails('differentPerceptionInBodyHalfs', value)"
        />
        <SectionHeader text="Since when do you feel the disruption?" :required="false" :dark="true" />
        <Dropdown
          label="please choose"
          :data="['A few hours', '1 day', '2 to 6 days', 'More than 1 week', '1 month']"
          :choice="store.numbnessDetails.since"
          v-on:action="value => store.addNumbnessDetails('since', value)"
        />
        <SectionHeader text="how" :required="false" :dark="true" />
        <Dropdown
          label="please choose"
          :data="['Creeping', 'suddenly', 'caused by an injury / an accident', 'Triggered by a different incident']"
          :choice="store.numbnessDetails.how"
          v-on:action="value => store.addNumbnessDetails('how', value)"
        />
      </template>

      <SectionHeader text="paralysis" :required="true" :dark="true" />
      <YesNo
        :model="store.paralysisDeafnessPrickleDetails.paralysis"
        v-on:action="value => store.addParalysisDeafnessPrickleDetails('paralysis', value)"
      />

      <template v-if="store.paralysisDeafnessPrickleDetails.paralysis === 'yes'">
        <SectionHeader text="Please mark the symptoms' location" :required="false" :dark="true" />
        <Bodyparts 
          :model="store.paralysisDetails.location"
          v-on:action="value => store.addParalysisDetails('location', value)"
        />
        <SectionHeader text="My current disruption is limited to one half of my body" :required="false" :dark="true" />
        <YesNo 
          :model="store.paralysisDetails.limitedToOneBodyHalf"
          v-on:action="value => store.addParalysisDetails('limitedToOneBodyHalf', value)"
        />
        <SectionHeader text="Since when do you feel the disruption?" :required="false" :dark="true" />
        <Dropdown
          label="please choose"
          :data="['A few hours', '1 day', '2 to 6 days', 'More than 1 week', '1 month']"
          :choice="store.paralysisDetails.since"
          v-on:action="value => store.addParalysisDetails('since', value)"
        />
        <SectionHeader text="how" :required="false" :dark="true" />
        <Dropdown
          label="please choose"
          :data="['Creeping', 'suddenly', 'caused by an injury / an accident', 'Triggered by a different incident']"
          :choice="store.paralysisDetails.how"
          v-on:action="value => store.addParalysisDetails('how', value)"
        />
        <SectionHeader text="feelingDizzy" :required="false" :dark="true" />
        <YesNo 
          :model="store.paralysisDetails.feelingDizzy"
          v-on:action="value => store.addParalysisDetails('feelingDizzy', value)"
        />
      </template>

      <SectionHeader text="prickle" :required="true" :dark="true" />
      <YesNo
        :model="store.paralysisDeafnessPrickleDetails.prickle"
        v-on:action="value => store.addParalysisDeafnessPrickleDetails('prickle', value)"
      />

      <template v-if="store.paralysisDeafnessPrickleDetails.prickle === 'yes'">
        <SectionHeader text="Please mark the symptoms' location" :required="false" :dark="true" />
        <Bodyparts 
          :model="store.prickleDetails.location"
          v-on:action="value => store.addPrickleDetails('location', value)"
        />
        <SectionHeader text="The current disruption is limited to one side of the body" :required="false" :dark="true" />
        <YesNo 
          :model="store.prickleDetails.limitedToOneBodyHalf"
          v-on:action="value => store.addPrickleDetails('limitedToOneBodyHalf', value)"
        />
        <SectionHeader text="Since when do you feel the disruption?" :required="false" :dark="true" />
        <Dropdown
          label="please choose"
          :data="['A few hours', '1 day', '2 to 6 days', 'More than 1 week', '1 month']"
          :choice="store.prickleDetails.since"
          v-on:action="value => store.addPrickleDetails('since', value)"
        />
        <SectionHeader text="How did the disruption set in?" :required="false" :dark="true" />
        <Dropdown
          label="please choose"
          :data="['Creeping', 'suddenly', 'caused by an injury / an accident', 'Triggered by a different incident']"
          :choice="store.prickleDetails.how"
          v-on:action="value => store.addPrickleDetails('how', value)"
        />
        <SectionHeader text="How do you describe the quality of the disruption?" :required="false" :dark="true" />
        <Dropdown
          label="please choose"
          :data="['increasing', 'constant', 'decreasing', 'Varying, sometimes more, sometimes less intense', 'Changing its location', 'Under mechanic pressure more intense', 'Getting less intense when I am moving', 'Getting more intense when I am moving']"
          :choice="store.prickleDetails.quality"
          v-on:action="value => store.addPrickleDetails('quality', value)"
        />
      </template>

      <SectionHeader text="lossOfPower" :required="true" :dark="true" />
      <YesNo
        :model="store.paralysisDeafnessPrickleDetails.lossOfPower"
        v-on:action="value => store.addParalysisDeafnessPrickleDetails('lossOfPower', value)"
      />

      <template v-if="store.paralysisDeafnessPrickleDetails.lossOfPower === 'yes'">
        <SectionHeader text="Please mark the symptoms' location" :required="false" :dark="true" />
        <Bodyparts 
          :model="store.lossOfPowerDetails.location"
          v-on:action="value => store.addLossOfPowerDetails('location', value)"
        />
        <SectionHeader text="The disruption is limited to one half of my body" :required="false" :dark="true" />
        <YesNo 
          :model="store.lossOfPowerDetails.limitedToOneBodyHalf"
          v-on:action="value => store.addLossOfPowerDetails('limitedToOneBodyHalf', value)"
        />
        <SectionHeader text="Since when do you feel the disruption?" :required="false" :dark="true" />
        <Dropdown
          label="please choose"
          :data="['A few hours', '1 day', '2 to 6 days', 'More than 1 week', '1 month']"
          :choice="store.lossOfPowerDetails.since"
          v-on:action="value => store.addLossOfPowerDetails('since', value)"
        />
        <SectionHeader text="How did the disruption set in?" :required="false" :dark="true" />
        <Dropdown
          label="please choose"
          :data="['Creeping', 'suddenly', 'caused by an injury / an accident', 'Triggered by a different incident']"
          :choice="store.lossOfPowerDetails.how"
          v-on:action="value => store.addLossOfPowerDetails('how', value)"
        />
      </template>
      
      <Button :text="edit ? 'Update' : 'Submit'" v-on:action="submit" :active="store.paralysisDeafnessPrickleDetailsComplete" />
    </template>
  </div>
</template>

<script>
import { observer } from "mobx-vue";

import SectionHeader from "../SectionHeader"
import YesNo from '../YesNo'
import Button from '../Button'
import Bodyparts from '../Bodyparts'
import Dropdown from '../Dropdown'
import CheckboxList from '../CheckboxList'
export default observer({
  name: "ParalysisDeafnessPrickle",
  data() {
    return {
      collapsed: true
    };
  },
  props: {
    store: Object,
    edit: Boolean
  },
  components: {
    SectionHeader, YesNo, Button, Bodyparts, Dropdown, CheckboxList
  },
  methods: {
    submit: function() {
      this.store.paralysisDeafnessPrickleDetails.submitted = true
      for (const detail in this.store.paralysisDeafnessPrickleDetails) {
        const value = this.store.paralysisDeafnessPrickleDetails[detail]
        if (value === 'yes' && typeof this.store[detail+'Details'] === 'object') {
          localStorage.setItem(
            detail+'Details',
            JSON.stringify(this.store[detail+'Details'])
          )
        }
      }
      localStorage.setItem(
        "paralysisDeafnessPrickleDetails",
        JSON.stringify(this.store.paralysisDeafnessPrickleDetails)
      )
      if (this.edit) {
        this.$emit('close')
      } else {
        this.collapsed = !this.collapsed
        window.scrollTo(0,0)
      }
    }
  }
})
</script>

<style>
</style>